import { CampaignProduct } from "../dto/campaign-product.model";

	/**
	 * @description
	 *  Ítems de reemplazo asociados a una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/ReplacementItemForGet.cs
	 */

export class ReplacementItemForGet {

	public campaignProductReplacementId: number;
	public code: string;
	public id: number;
	public name: string;
	public orderEventId: number;
	public price: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un ítem de reemplazo con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem de reemplazo vacío.
	 */
	public static empty(): ReplacementItemForGet {
		const replacementItemForGet: ReplacementItemForGet = new ReplacementItemForGet();
		replacementItemForGet.campaignProductReplacementId = undefined;
		replacementItemForGet.code = "";
		replacementItemForGet.id = undefined;
		replacementItemForGet.name = "";
		replacementItemForGet.orderEventId = undefined;
		replacementItemForGet.price = undefined;
		replacementItemForGet.quantity = undefined;
		return replacementItemForGet;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicReplacementItemForGet
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicReplacementItemForGet: ReplacementItemForGet): ReplacementItemForGet {
		if (!anemicReplacementItemForGet) return undefined;
		const replacementItemForGet: ReplacementItemForGet = ReplacementItemForGet.empty();
		replacementItemForGet.campaignProductReplacementId = anemicReplacementItemForGet.campaignProductReplacementId;
		replacementItemForGet.code = anemicReplacementItemForGet.code;
		replacementItemForGet.id = anemicReplacementItemForGet.id;
		replacementItemForGet.name = anemicReplacementItemForGet.name;
		replacementItemForGet.orderEventId = anemicReplacementItemForGet.orderEventId;
		replacementItemForGet.price = anemicReplacementItemForGet.price;
		replacementItemForGet.quantity = anemicReplacementItemForGet.quantity;
		return replacementItemForGet;
	}

	/**
	 * @description
	 *	Crea una nueva instancia de un producto de campaña desde este modelo.
	 *	Nótese que debido a la conversión, el campo 'quantity' se pierde y
	 *	debe almacenarse fuera del objeto.
	 *
	 * @returns
	 *	Una vista de este modelo como CampaignProduct.
	 */
	 public asCampaignProduct(): CampaignProduct {
		const campaignProduct = CampaignProduct.empty();
		campaignProduct.id = this.campaignProductReplacementId;
		campaignProduct.price = this.price;
		campaignProduct.product.code = this.code;
		campaignProduct.product.name = this.name;
		return campaignProduct;
	}

	/**
	 * @description
	 *	Computa el precio de folleto de este ítem.
	 *
	 * @returns
	 *	El precio de folleto total para este ítem.
	 */
	public totalBrochurePrice(): number {
		return this.quantity * this.price;
	}
}
